import { FileUp } from "lucide-react"
import type { NotificationRenderer } from "../../types"
import { navigateForAction } from "../actionRoutes"

// Icon mirrors the sidebar's questionnaire entry (AppSidebarV2 ICONS.upload).
export const taggedMissingAnswer: NotificationRenderer = {
  icon: FileUp,
  accent: "default",
  title: () => ({ key: "NOTIF/TAGGED/TITLE" }),
  description: () => ({ key: "NOTIF/TAGGED/DESC" }),
  cta: "NOTIF/CTA/OPEN_QUESTION",
  onAction: navigateForAction,
}
